module.exports = __webpack_public_path__ + "img/ic_daifukuan.8a0c376a.svg";